module.exports = __webpack_public_path__ + "img/public/SiteIcons/cvvIcon.svg?e2d1e0b4";